import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

export const ChangeViewOfProducts = () => {
  const { isGridView, setIsGridView } = useContext(GlobalContext);
  return (
    <div className="sort-filters">
      <div className="card-row">
        <a
          href=""
          role="button"
          className={`grid-products d-flex ${isGridView ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            setIsGridView(true);
          }}
        >
          <span className="wes-card-filter" />
        </a>
        <a
          href=""
          role="button"
          className={`row-products d-flex ${isGridView ? "" : "active"}`}
          onClick={(e) => {
            e.preventDefault();
            setIsGridView(false);
          }}
        >
          <span className="wes-row-filter" />
        </a>
      </div>
    </div>
  );
};
